import { render } from "./ReviewSwiper.vue?vue&type=template&id=13e82105&scoped=true"
import script from "./ReviewSwiper.vue?vue&type=script&lang=js"
export * from "./ReviewSwiper.vue?vue&type=script&lang=js"

import "./ReviewSwiper.vue?vue&type=style&index=0&id=13e82105&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13e82105"]])

export default __exports__